import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import About from '@/pages/about/page';
import Technology from '@/pages/technology/page';
import Products from '@/pages/products/page';
import Solutions from '@/pages/solutions/page';
import Partnership from '@/pages/partnership/page';
import Sustainability from '@/pages/sustainability/page';
import Contact from '@/pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/technology',
    element: <Technology />,
  },
  {
    path: '/products',
    element: <Products />,
  },
  {
    path: '/solutions',
    element: <Solutions />,
  },
  {
    path: '/partnership',
    element: <Partnership />,
  },
  {
    path: '/sustainability',
    element: <Sustainability />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
